export default `
  mutation deleteUserAccount($userId: ID!) {
    deleteUserAccount(userId: $userId) {
      deletedAt
      cleared
      blockedReason
    }
  }
`
